import { sortEventBatchesByStartDateAsc } from './sortEventBatchesByStartDateDesc.js';
import { UPCOMING_REGISTRATION_TYPE } from './leadRequestDisplay.js';

/** Params for lead edit: all active batches for the trek (not only future). */
export function leadEditBatchListParams(trekId) {
  return {
    trekId,
    limit: 200,
    sortBy: 'startDate',
    sortOrder: 'asc'
  };
}

export function resolveLeadEditTrekId({ lead, booking, trekIdFromSlug }) {
  if (lead?.leadType === UPCOMING_REGISTRATION_TYPE) {
    return booking?.batch?.trek?.id ?? lead?.trekId ?? trekIdFromSlug ?? null;
  }
  return trekIdFromSlug ?? lead?.trekId ?? null;
}

/** Ensure the lead's current batch appears in the dropdown (even if not "upcoming"). */
export function mergeCurrentBatchForLeadSelect(apiBatches, { batchId, booking, lead }) {
  const sorted = sortEventBatchesByStartDateAsc(apiBatches || []);
  const id = batchId ? String(batchId) : '';
  if (!id) return sorted;
  if (sorted.some((b) => String(b.id) === id)) return sorted;

  const fromBooking = booking?.batch;
  if (fromBooking && String(fromBooking.id) === id) {
    return sortEventBatchesByStartDateAsc([fromBooking, ...sorted]);
  }

  if (lead?.batchStartDate || lead?.eventDateLabel) {
    const stub = {
      id: Number(id),
      startDate: lead.batchStartDate || null,
      endDate: lead.batchEndDate || null,
      code: '',
      trekId: lead?.trekId ?? null
    };
    return sortEventBatchesByStartDateAsc([stub, ...sorted]);
  }

  return sorted;
}

export function resolveLeadEditBatchId(lead, booking) {
  const fromBooking = booking?.batch?.id ?? booking?.batchId;
  const fromLead = lead?.batchId;
  const id = fromBooking ?? fromLead;
  return id != null && String(id).trim() !== '' ? String(id) : '';
}
